import { Provider } from "jotai";
import React from "react";
import { estFichePersonnelle } from "../../../../../../helpers/ficheClient";
import useClientItem from "../useClientItem";
import CompanyItem from "./CompanyItem/CompanyItem";

const CompanyList = () => {
  const { client } = useClientItem();

  return (
    <div>
      {client.clients
        // Vue sociétés : les fiches personnelles (PER-2209) ne sont pas des
        // sociétés et n'ont pas leur place ici (revue finale sprint 25).
        .filter((company) => !estFichePersonnelle(company))
        .map((company) => (
          <Provider key={`companyitem${company.id}`}>
            <CompanyItem companyData={company} />
          </Provider>
        ))}
    </div>
  );
};

export default CompanyList;
